<template lang="pug">
  .grid.is-ultrawide-5.is-widescreen-6.is-desktop-7.is-tablet-8.is-center
    .column(data-cy="signin-methods")
      h3.u-mb-sm {{ $t('welcome') }}
      //- p.u-text-lg.u-mb-sm {{ $t('accountPerks') }}
      ValidationObserver(v-if="!waitForCode" v-slot="{ validate }" ref="form")
        form(@submit.prevent="validate().then(onSubmit)")
          .grid.is-6.is-tiny
            .column
              TextInput(
                type="text"
                :label="$t('forms.fname')"
                v-model="firstName"
                rules="required"
              )
            .column
              TextInput(
                type="text"
                :label="$t('forms.lname')"
                v-model="lastName"
                rules="required"
              )
          TextInput(
            :name="$t('v-email')"
            :autofocus="true"
            type="email"
            :label="$t('forms.email')"
            v-model="email"
            rules="required|email|unique_email"
          )

          PhoneInput(
            :name="$t('v-phone')"
            type="text"
            :label="$t('forms.phone')"
            v-model="phone"
            rules="required"
          )

          .u-mb-ts
            recaptcha(@error="onError" @success="onSuccess" @expired="onExpired")
          button.button-link.is-medium(v-load="isSubmitting") {{ $t('forms.signup') }}

      ValidationObserver(v-else v-slot="{ validate }" ref="form")
        form(@submit.prevent="validate().then(confirmSMS)")
          TextInput(
            name="code"
            :autofocus="true"
            type="text"
            :label="$t('smsCode')"
            v-model="code"
            rules="required|numeric|min:6"
          )
          button.button-link.is-medium(v-load="isSubmitting") {{ $t('forms.signin') }}

      p.u-mt-sm {{ $t('forms.already') }} #[AppLink(to="/login" :title="$t('forms.signin') " class="u-super") {{ $t('forms.signin') }}]

</template>

<script>
import { ValidationObserver } from 'vee-validate/dist/vee-validate.minimal';
import { load } from '~/directives';
import TextInput from '~/components/inputs/TextInput';
import PhoneInput from '~/components/inputs/PhoneInput';
import { Register, LoginWithSms } from '~/graphql/Auth.graphql';

const Cookies = process.client ? require('js-cookie') : undefined;

export default {
  name: 'LoginForm',
  directives: {
    load
  },
  components: {
    TextInput,
    ValidationObserver,
    PhoneInput
  },
  data: () => ({
    isSubmitting: false,
    waitForCode: false,
    firstName: '',
    phone: '',
    lastName: '',
    email: '',
    code: '',
    recaptchaValid: false
  }),
  created() {
    if (process.server) return;

    const method = localStorage.getItem('loginMethod');
    if (method) {
      this.method = method;
      localStorage.removeItem('loginMethod');
    }
  },
  methods: {
    async onSubmit() {
      try {
        if (!this.recaptchaValid) {
          this.error(this.$t('forms.recaptchaRequired'));
          return;
        }
        this.isSubmitting = true;
        const { data } = await this.$api.mutate({
          mutation: Register,
          variables: {
            input: {
              firstName: this.firstName,
              lastName: this.lastName,
              phone: this.phone,
              email: this.email,
              app: 'BAIANAT_WEB',
              callbackUrl: `${this.$store.state.env.APP_URL}/auth/email/callback`
            }
          }
        });

        requestAnimationFrame(() => {
          this.$refs.form.reset();
          if (data.register.success) {
            this.waitForCode = true;
          }
          this.$success(this.$t('success'));
        });
        await this.$recaptcha.reset();
        this.recaptchaValid = false;
      } catch (err) {
        console.error(err);
        this.$error(err.message);
      } finally {
        this.isSubmitting = false;
      }
    },
    async confirmSMS() {
      try {
        this.isSubmitting = true;
        const { data } = await this.$api.mutate({
          mutation: LoginWithSms,
          variables: {
            input: {
              phone: this.phone,
              token: this.code
            }
          }
        });

        this.$store.commit('auth/SET_USER', data.loginWithSms.user);
        this.$store.commit('auth/SET_TOKEN', data.loginWithSms.token);
        Cookies.set('auth', data.loginWithSms.token, {
          expires: 7,
          path: '/'
        });
        this.$store.commit('auth/SET_PERMISSIONS', data.loginWithSms.user.permissions);
        this.$store.commit('auth/SET_UPDATED', true);
        this.$store.dispatch('notifications/fetch');
        this.$ws.connect();
        this.$router.localePush('/cc');
      } catch (err) {
        console.error(err);
        this.$error(err.message);
      } finally {
        this.isSubmitting = false;
      }
    },
    onError() {
      // console.log('Error happened:', error);
      this.recaptchaValid = false;
    },
    onSuccess() {
      // console.log('Succeeded:', token);
      this.recaptchaValid = true;
    },
    onExpired() {
      // console.log('Expired');
      this.recaptchaValid = false;
    }
  },
  async mounted() {
    try {
      await this.$recaptcha.init();
    } catch (e) {
      console.error(e);
    }
  }
};
</script>

<i18n>
{
  "en": {
    "welcome": "Register",
    "accountPerks": "One account gets you into everything Baianat offers.",
    "success": "We sent you an SMS to your phone and a login link to your email. You can use either to login to your account.",
    "smsCode": "Login Code",
    "signUpWithEmail": "Want to sign up with email instead?",
    "signUpWithPhone": "Want to sign up with phone instead?",
    "switchMethod": "Click here",
    "v-email":"Email",
    "v-phone":"Phone"
  },
  "ar": {
    "welcome": "إنشاء حساب",
    "accountPerks": "حساب واحد يمنحك كل العروض الخاصة ببيانات.",
    "success": "تم ارسال رسالة الى هاتفك وبريدك الاليكتروني, يمكنك استعمال اياً منهم لتسجيل الدخول.",
    "smsCode": "كود الدخول",
    "signUpWithEmail": "تريد التسجيل بالبريد الاليكتروني؟",
    "signUpWithPhone": "هل تود التسجيل برقم الهاتف؟",
    "switchMethod": "اضغط هنا",
    "v-email":"البريد الالكتروني",
    "v-phone":"رقم الهاتف"
  }
}
</i18n>
